import { Directive, effect, inject, input } from '@angular/core';
import { MatButton, MatButtonAppearance } from '@angular/material/button';

export type CcsButtonVariant = 'primary' | 'secondary';
export type CcsButtonSize = 'sm' | 'md' | 'lg';

const APPEARANCES: Record<CcsButtonVariant, MatButtonAppearance> = {
  primary: 'filled',
  secondary: 'outlined',
};

/** Matches the @ccs/ui companion directive API for a future library migration. */
@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector -- Preserve the @ccs/ui public API.
  selector: 'button[ccsButton], a[ccsButton]',
  host: {
    class: 'ccs-button',
    '[class.ccs-button--secondary]': "ccsButton() === 'secondary'",
    '[class.ccs-button--sm]': "ccsSize() === 'sm'",
    '[class.ccs-button--lg]': "ccsSize() === 'lg'",
  },
})
export class CcsButtonDirective {
  private readonly _matButton = inject(MatButton, { self: true, optional: true });

  readonly ccsButton = input.required<CcsButtonVariant>();
  readonly ccsSize = input<CcsButtonSize>('md');

  constructor() {
    if (!this._matButton) {
      throw new Error('ccsButton requires the matButton attribute on the same element.');
    }
    effect(() => this._matButton?.setAppearance(APPEARANCES[this.ccsButton()]));
  }
}
